import React, { Fragment } from "react";
import {
  NextStatus,
  StatusArea,
  StatusDiv,
  StatusDivFree,
  StatusIcon,
  StatusText,
  StatusTextAfter,
} from "./ReserveStyle";

import IconWatingOn from "../../resources/images/icon/newIcon/icon_state_waiting_active.png";
import IconWatingOff from "../../resources/images/icon/newIcon/icon_state_waiting_nor.png";
import IconConfirmOn from "../../resources/images/icon/newIcon/icon_state_rconfirm_active.png";
import IconConfirmOff from "../../resources/images/icon/newIcon/icon_state_rconfirm_nor.png";
import IconReceiptOn from "../../resources/images/icon/newIcon/icon_state_receipt_active.png";
import IconReceiptOff from "../../resources/images/icon/newIcon/icon_state_receipt_nor.png";
// import IconCancel from "../../resources/images/icon/newIcon/icon_state_cancel_nor.png";
import IconCancel from "../../resources/images/icon/newIcon/icon_inspection_confirm_past_color.svg";

import IconLocation from "../../resources/images/icon/icon_location_line.png";
import IconPolygon from "../../resources/images/icon/newIcon/polygon.svg";

import IconNext from "../../resources/images/icon/newIcon/chevron-right.svg";
import { NftfWatingSrc } from "../../resources/Assets";

const CardStatus = (props) => {
  const { data } = props;
  return (
    <Fragment>
      {data.appCls === "0" && <StatusIcon0 data={data} />}
      {data.appCls === "1" && <StatusIcon1 data={data} />}
      {data.appCls === "9" && <StatusIcon9 data={data} />}
    </Fragment>
  );
};

const StatusIcon0 = (props) => {
  const { data } = props;
  // appStatus 1 || 2 || 8 -> active true (접수중)
  // appStatus 7 -> active true (방문진료)
  return (
    <Fragment>
      {parseInt(data.appStatus) < 8 ? (
        <Fragment>
          <Status
            image={
              data.appStatus == 1 || data.appStatus == 2 || data.appStatus == 8
                ? IconWatingOn
                : IconWatingOff
            }
            active={
              data.appStatus == 1 || data.appStatus == 2 || data.appStatus == 8 ? true : false
            }
            text="접수중"
          />
          <NextStatus>
            <img src={IconNext} />
          </NextStatus>
          <Status
            image={data.appStatus == 7 ? IconReceiptOn : IconReceiptOff}
            active={data.appStatus == 7 ? true : false}
            text="방문진료"
          />
        </Fragment>
      ) : (
        <Fragment>
          <Status
            image={IconCancel}
            active={true}
            text={data.appStatus == 8 ? "병원마감" : "예약취소"}
          />
        </Fragment>
      )}
    </Fragment>
  );
};

const StatusIcon1 = (props) => {
  const { data } = props;

  // 5 지연
  // 4,5,7 이면서 openTime 여부 확인 있으면 비대면 아니면 예약확정

  return (
    <Fragment>
      {parseInt(data.appStatus) < 8 ? (
        data.telmdcnToDh && data.telmdcnToDh != "" ? (
          <Fragment>
            <Fragment>
              <StatusFree image={NftfWatingSrc} active={true} text="비대면 진료 종료" />
            </Fragment>
          </Fragment>
        ) : (
          <Fragment>
            <Status
              image={data.appStatus == 1 || data.appStatus == 2 ? IconWatingOn : IconWatingOff}
              active={data.appStatus == 1 || data.appStatus == 2 ? true : false}
              text="예약대기"
            />
            <NextStatus>
              <img src={IconNext} />
            </NextStatus>
            <Status
              image={
                (data.appStatus == 4 || data.appStatus == 5 || data.appStatus == 7) &&
                data.telmdcnOpenYn === "N"
                  ? IconConfirmOn
                  : IconConfirmOff
              }
              active={
                (data.appStatus == 4 || data.appStatus == 5 || data.appStatus == 7) &&
                data.telmdcnOpenYn === "N"
                  ? true
                  : false
              }
              text="예약확정"
            />
            <NextStatus>
              <img src={IconNext} />
            </NextStatus>
            <Status
              image={
                (data.appStatus == 4 || data.appStatus == 5 || data.appStatus == 7) &&
                data.telmdcnOpenYn === "Y"
                  ? IconReceiptOn
                  : IconReceiptOff
              }
              active={
                (data.appStatus == 4 || data.appStatus == 5 || data.appStatus == 7) &&
                data.telmdcnOpenYn === "Y"
                  ? true
                  : false
              }
              text="비대면 진료"
            />
          </Fragment>
        )
      ) : (
        <Fragment>
          <Status
            image={IconCancel}
            active={true}
            text={data.appStatus == 10 ? "병원반려" : "예약취소"}
          />
        </Fragment>
      )}
    </Fragment>
  );
};

const StatusIcon9 = (props) => {
  // appStatus 1:가예약 2:확정예약 3:취소완료(확정예약)
  const { data } = props;
  return (
    <Fragment>
      {parseInt(data.appStatus) < 3 ? (
        <Fragment>
          <Status
            image={data.appStatus == 1 ? IconWatingOn : IconWatingOff}
            active={data.appStatus == 1 ? true : false}
            text="가예약"
          />
          <NextStatus>
            <img src={IconNext} />
          </NextStatus>
          <Status
            image={data.appStatus == 2 ? IconConfirmOn : IconConfirmOff}
            active={data.appStatus == 2 ? true : false}
            text="예약확정"
          />
        </Fragment>
      ) : (
        <Fragment>
          <Status image={IconCancel} active={false} text={"예약취소"} />
        </Fragment>
      )}
    </Fragment>
  );
};

const Status = (props) => {
  return (
    <StatusDiv>
      <StatusIcon image={props.image} />
      <StatusArea>
        {props.active && <img src={IconPolygon} />}
        {/* {props.active && <StatusTextAfter />} */}
        <StatusText active={props.active}>{props.text}</StatusText>
      </StatusArea>
    </StatusDiv>
  );
};

const StatusFree = (props) => {
  return (
    <StatusDivFree>
      <StatusIcon image={props.image} />
      <StatusArea>
        {props.active && <img src={IconPolygon} />}
        {/* {props.active && <StatusTextAfter />} */}
        <StatusText active={props.active}>{props.text}</StatusText>
      </StatusArea>
    </StatusDivFree>
  );
};

export default CardStatus;
